<div class="container-fluid">
  <popupWindow ref="popupComponent" style="z-index: 9999;" />
  <div class="row">
    <!-- Left side: Payment system image -->
    <div class="col-md-8 col-sm-8 d-none d-md-block p-0">
      <img src="../../assets/loginPageBanner.png" alt="Payment System" class="img-fluid"
        style="height: 100vh; width: 100%;">
    </div>

    <div class="col-md-4 p-4 d-flex flex-column align-items-center" style="height: 100vh;">
      <img src="../../assets/clarity_pay_logo.png" alt="logo" class="img-fluid mb-4" style="height: 55px; margin-left: -20px; align-self: baseline;">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title text-start mb-4 fw-bold">Welcome to ClarityPay.<br><span
              style="font-size: 15px; font-weight: normal !important;">Please login to continue</span></h5>
          <form @submit.prevent="login">
            <div class="mb-3">
              <input type="text" class="form-control" id="username" v-model="username" placeholder="Email or Username"
                required>
            </div>
            <div class="mb-3">
              <input type="password" class="form-control" id="password" v-model="password" placeholder="Password"
                required>
            </div>
            <button type="submit" class="btn btn-primary w-100 fw-bold">Login</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>